import React, { useEffect, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Loading from "./components/common/Loading";
import WhatsAppButton from "./components/common/WhatsAppButton";

// Lazy loading de páginas
const HomePage = lazy(() => import("./pages/HomePage"));
const SolucionesHogar = lazy(() => import("./pages/SolucionesHogar"));
const SolucionesEmpresas = lazy(() => import("./pages/SolucionesEmpresas"));
const QuienesSomos = lazy(() => import("./pages/QuienesSomos"));
const Contacto = lazy(() => import("./pages/Contacto"));
const DesarrolloWeb = lazy(() => import("./pages/DesarrolloWeb"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Componente para scroll al tope en cambio de ruta
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll instantáneo al cambiar de página para no perder las animaciones de entrada
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/soluciones-hogar" element={<SolucionesHogar />} />
              <Route
                path="/soluciones-empresas"
                element={<SolucionesEmpresas />}
              />
              <Route path="/quienes-somos" element={<QuienesSomos />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/desarrollo-web" element={<DesarrolloWeb />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
